import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useAuthStore from '../store/authStore';

export default function DoctorDropdown({ value, onChange, label = 'Doctor', required = false, className = '', placeholder = 'Select doctor' }) {
  const [doctors, setDoctors] = useState([]);
  const token = useAuthStore(s => s.token);

  useEffect(() => {
    axios.get('/api/ipd/doctors', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        const seen = new Set();
        const unique = (r.data || []).filter(d => {
          if (!d.name || seen.has(d.name)) return false;
          seen.add(d.name);
          return true;
        });
        setDoctors(unique);
      })
      .catch(() => {});
  }, [token]);

  return (
    <div className={className}>
      {label && <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 4 }}>{label}{required && ' *'}</label>}
      <select
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        required={required}
        style={{
          width: '100%', padding: '8px 10px', border: '1px solid #d1d5db',
          borderRadius: 6, fontSize: 14, backgroundColor: '#fff'
        }}
      >
        <option value="">{placeholder}</option>
        {doctors.map(d => (
          <option key={d.id} value={d.name}>{d.name}</option>
        ))}
      </select>
    </div>
  );
}
